/**
 * Public landing page ("/") — shown to logged-out visitors.
 *
 * Implements the FinminOS landing Figma (developers file → FinminOS page):
 * every "File Your ITR Now" CTA routes to /login; authenticated visitors are
 * redirected to /dashboard before this ever renders (see routes/index.tsx).
 */
import './landing.css';
import { HeroSection, LandingHeader } from './hero-section';
import {
  HowItWorksSection,
  PlatformSection,
  TestimonialsSection,
  TrustSection,
} from './content-sections';
import {
  FinalCtaSection,
  FinOsSection,
  TeamSection,
  WhySection,
} from './closing-sections';
import { FloatingDeadlinePopup, LandingFooter } from './footer';

export function LandingPage() {
  return (
    <div className="min-h-screen overflow-x-clip bg-cream font-landing-body">
      <LandingHeader />
      <main>
        <HeroSection />
        <TrustSection />
        <PlatformSection />
        <TestimonialsSection />
        <HowItWorksSection />
        <FinOsSection />
        <WhySection />
        <TeamSection />
        <FinalCtaSection />
      </main>
      <LandingFooter />
      <FloatingDeadlinePopup />
    </div>
  );
}
